import { ActionTree } from "vuex";
import { ActionCallback, RootState } from "../types";
import { CandidateState } from "./types";
import CandidateService from "@/services/candidate.service";
import { AxiosError, AxiosResponse } from "axios";
import toast from "@/functions/toast.function";
const service: CandidateService = new CandidateService();

export const actions: ActionTree<CandidateState, RootState> = {};
